import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router';

import AgentPortalError from 'errors/AgentPortalError';
import { getRefundMethodsURL } from 'utils/urls';

import { CANCEL_INSURANCE_PRODUCT } from 'store/mutations';
import ManageInsurance from './ManageInsurance';

const ManageInsuranceContainer = ({ bookingReference, passenger, date, policyNumber, currency, price, itemRef }) => {
  const { push } = useHistory();

  const [cancelInsuranceProduct, { loading, error }] = useMutation(CANCEL_INSURANCE_PRODUCT, {
    onCompleted: ({ cancelInsuranceProduct: { paymentsRefundBalance } }) => {
      if (paymentsRefundBalance < 0) {
        push(getRefundMethodsURL(bookingReference, currency, null, true));
      }
    },
    refetchQueries: ['booking'],
    awaitRefetchQueries: true
  });

  const handleCancel = async ({ fee }) => {
    await cancelInsuranceProduct({
      variables: {
        bookingReference,
        fee,
        itemRef
      }
    });
  };

  if (error) {
    throw new AgentPortalError(error);
  }

  return (
    <ManageInsurance
      currency={currency}
      date={date}
      passenger={passenger}
      policyNumber={policyNumber}
      loading={loading}
      price={price}
      onCancel={handleCancel}
    />
  );
};

ManageInsuranceContainer.propTypes = {
  bookingReference: PropTypes.string.isRequired,
  passenger: PropTypes.string.isRequired,
  itemRef: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  policyNumber: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired
};

export default ManageInsuranceContainer;
